import { render } from "./ContentShowcase.vue?vue&type=template&id=25257b52&scoped=true"
const script = {}

import "./ContentShowcase.vue?vue&type=style&index=0&id=25257b52&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25257b52"]])

export default __exports__